// extracted by mini-css-extract-plugin
export default {"root":"NotFoundData_root__p4nn7","label":"NotFoundData_label__nGrPk","description":"NotFoundData_description__AjEYr","title":"NotFoundData_title__2mT1-"};